// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

common.View.create('canvas.blocks.custom.latestNewsSwiper.Block', {

    onDOMLoad() {
        this.initSwiper();
    },

    initSwiper() {
        let swiper = new Swiper(".mySwiper", {
            effect: "coverflow",
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: "auto",
            initialSlide: 2,
            spaceBetween: 5,
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 500,
                modifier: 1,
            },
            // breakpoints: {
            //     320: {
            //         slidesPerView: 2,
            //     },
            //     1024: {
            //         slidesPerView: 5,
            //     },
            // },
        });

        let swiper2 = new Swiper(".mySwiper2", {
            spaceBetween: 10,
            initialSlide: 2,
            centeredSlides: true,
            slidesPerView: "auto",
            navigation: {
                nextEl: ".swiper-button-next-custom",
                prevEl: ".swiper-button-prev-custom",
            },
        });

        swiper.controller.control = swiper2;
        swiper2.controller.control = swiper;
    },

});
